import { translate } from '@/core/localization/translate';
export const {
  ariaLabelPrevious,
  ariaLabelNext
} = translate({
  "ariaLabelPrevious": "Previous",
  "ariaLabelNext": "Next"
});